import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "sourceSelect",
        "fieldset",
    ]

    connect() {
        // Avoid UI flickering
        Turbolinks.clearCache();
        // Delay to let Select2 instances to correctly initialize
        setTimeout(() => {
            this.toggle();
        }, 10)
    }

    toggle() {
        let sourceSelected = this.sourceSelectTarget.options[this.sourceSelectTarget.selectedIndex];
        let displayTarget = false;
        if (sourceSelected) {
            if (sourceSelected.dataset.toggleVisibility) {
                displayTarget = sourceSelected.dataset.toggleVisibility === 'true';
            } else {
                displayTarget = sourceSelected.text.length > 0;
            }
        }
        this.fieldsetTargets.forEach(fieldset => {
            fieldset.disabled = !displayTarget;
            fieldset.style.display = displayTarget ? "block" : "none";
        });
    }

}